import { parseEther } from '@ethersproject/units';
import { useContext } from 'react';
import Button from '../../../../components/Button';
import Detail from '../../../../components/Detail';
import modalContext from '../../../../context/modal/modalContext';
import { formatUSD } from '../../../../helpers/formats';
import useUserStakedSpool from '../../../../hooks/web3/vault/useUserStakedSpool';

const Unstake = () => {
    const { openModal } = useContext(modalContext);

    const { userStakedSpool } = useUserStakedSpool();

    const unstake = () => {
        openModal('unstakeModal');
    };

    return (
        <Detail
            title='Your Total $SPOOL Staked'
            value={
                <>
                    {formatUSD(userStakedSpool || 0)} $SPOOL
                    <Button
                        variant='secondary'
                        onClick={unstake}
                        disabled={
                            !userStakedSpool || parseEther(userStakedSpool).isZero()
                        }
                    >
                        Unstake
                    </Button>
                </>
            }
        />
    );
};

export default Unstake;
